import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/ai/ai.ts
var textToFilter = (aiTextToFilterRequest, params, options) => {
  return customInstance(
    {
      url: `/api/v1/ai/text-to-filter`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aiTextToFilterRequest,
      params
    },
    options
  );
};
var rolledOutCountries = (options) => {
  return customInstance(
    {
      url: `/api/v1/ai/rolled-out-countries`,
      method: "GET"
    },
    options
  );
};

export {
  textToFilter,
  rolledOutCountries
};
